<template>  
   <div> 

  <!-- <v-container
        fluid
      > -->
  <v-layout column>
    <v-flex>
        <v-container
          fluid
          grid-list-md
        >
        <div class = "primary">
          <v-btn color="alerts"
      @click="createDiag = true"
        relative
        style="float: right; top: 5px"
        fab
        top
        right>
            <v-icon style="color:white">add</v-icon>

      </v-btn>


    <!-- <v-btn
        absolute
        fab
        dark
        right
        class="alerts"
            >
              <v-icon>search</v-icon>
      </v-btn> -->

        <v-subheader class="primary"  style="height: 85px">  <img src= "/static/img/official_icons/dashboard.png" style= "max-width: 8ex; max-height: 8ex;"> 
        <h1 class="primary" style="color:white; psition: relative; bottom: 10px">{{user.name.substr(0, user.name.indexOf(" "))}}'s Project Dashboard
      </h1> </v-subheader> 
          </div>
            <v-text-field
            append-icon="search"
            box
            placeholder="Search a project..."
            v-model="search"
            >
            </v-text-field>
          <v-layout row wrap class="scroll-y" id="scroll-target">

            <v-flex
              v-for="(project, index) in filteredProjects"
              v-bind="{ [`xs4`]: true }"
              :key="project.id"
              v-scroll:#scroll-target
            >
              <v-card color='grey lighten-2 pa-4' >
                <div @click="funct(project.id)">
                <v-card-title primary-title>
                  <h1 v-if="project.title.length < 30" class="headline mb-0" style="text-align:center">{{project.title}}</h1>
                <h1 v-if="project.title.length > 30" class="headline mb-0" style="text-align:center">{{project.title.substring(0, 30)}}...</h1>
                </v-card-title>
                

              <v-card-actions>

                <v-badge
                color="red"
                overlap>
                <span slot="badge" v-if="project.unreadMessages > 0">{{project.unreadMessages}}</span>
                  <v-btn color ='primary' @click="funct(project.id)">Open</v-btn>
                </v-badge>

              <v-spacer></v-spacer>
                <v-dialog v-model="project.projectDialog">
          <v-btn
            slot="activator"
            color="alerts"
            dark
            v-if="$store.getters.user.id === project.creatorID"
          >
            Delete
          </v-btn>
          <v-btn 
          v-else
          slot="activator"
            color="alerts"
            dark>Leave</v-btn>

          <v-card class style=" width: 100%; height: 150px" v-if="$store.getters.user.id === project.creatorID">
                    <v-card-title >
                      <h2> You want to delete the Project: {{project.title}}?</h2>
                      </v-card-title>
                      
                      <v-btn
                    color="alerts"
                    flat
                    dark
                    @click="deletes(project)"
                  >
                    Delete
                  </v-btn>
                    <v-btn
                    color="green"
                    flat
                    dark
                    @click="project.projectDialog = false"
                  >
                    Cancel
                  </v-btn>
                  </v-card>

<v-card v-else class style=" width: 100%; height: 150px">
  <v-card-title >
                      <h2> You want to leave the Project: {{project.title}}?</h2>
                      </v-card-title>
                      
                      <v-btn
                    color="alerts"
                    flat
                    dark
                    @click="leave(project)"
                  >
                    Leave
                  </v-btn>
                    <v-btn
                    color="green"
                    flat
                    dark
                    @click="project.projectDialog = false"
                  >
                    Cancel
                  </v-btn>
</v-card>

                  </v-dialog>

                <v-spacer></v-spacer>

                    <v-dialog
                  v-model="show[index]"
                  width="500"
                >

            <img slot = "activator" src = "/static/img/official_icons/info.png" style = "width: 6ex; height: 6ex">

          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              Details
            </v-card-title>

            <v-card-text>
              <div class='text-md-center pa-8 ma-4'>
                <v-card-title
                  primary-title
                >
                <h1 class='text-md-center'>
                  {{project.title.substring(0).toUpperCase()}}
                </h1>
                </v-card-title>

                <v-card-text>
                  <h2>Description</h2>
                {{project.description}}  
                </v-card-text>
                <v-card-text v-if="project.startDate !== 0">
                  <h2>Start Date</h2>
                {{dateFormat(project.startDate)}}  
                </v-card-text>
                <v-card-text v-if="project.endDate !== 0">
                  <h2>End Date</h2>
                {{dateFormat(project.endDate)}}  
                </v-card-text>

                 <v-card-text>
                  <h2>Members</h2>
                </v-card-text>

                <v-list>
                  <v-list-tile
                    v-for="member in members[project.id]"
                    :key="member.id + project.id + Math.random()"
                    avatar
                  >

                    <v-list-tile-avatar>
                      <img :src="member.photoURL">
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title >{{member.name}}</v-list-tile-title>
                    <v-spacer></v-spacer>

                    </v-list-tile-content>

                    <v-list-tile-action>
                      <div v-if="project.creator == member.name">
                        Creator
                        <v-icon color="primary">star</v-icon>
                      </div>
                      <!-- <v-icon v-else-if="meeting.no.includes(member.id)" color="error">highlight_off</v-icon>
                      <v-icon v-else color="secondary">help_outline</v-icon> -->
                    </v-list-tile-action>

                  </v-list-tile>
                </v-list>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                
              <v-btn
                color="primary"
                flat
                @click="showInfo(index)"
              >
                Close
              </v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card-actions>
</div>
          </v-card>
            </v-flex>
          </v-layout>
        </v-container>
    </v-flex>
  </v-layout>

  <!-- </v-container> -->
  <v-divider></v-divider>
   <v-dialog
   v-model="createDiag"
   style="width: 65%"
      width="1000">
   <v-btn
              absolute
              dark
              fab
              bottom
              right
              style="right: 75px; bottom: 15px"
              class="alerts"
              slot="activator"
            >
              <v-icon style="max-height: 8ex">add</v-icon>
            </v-btn>
            <v-project-diag v-on:cancel="createDiag = false" v-on:new="out"> </v-project-diag>
   </v-dialog>
            <v-btn
              absolute
              fab
              bottom
              right
              style="right: 150px; bottom: 15px"
              @click="$router.push('/calender')"
            >
              <img src="/static/img/official_icons/event2.png" style="max-height: 8ex">
            </v-btn>
            <v-btn
              absolute
              fab
              bottom
              right
              style="right: 225px; bottom: 15px"
              @click="$router.push('/profile/' + $store.getters.user.id)"
            >
              <img src="/static/img/official_icons/profile.png" style="max-height: 8ex">
            </v-btn>
 </div>
      
</template>

<script>

import Project from './Project.vue'
import ProjectDiag from './Projectdiag.vue'

import firebase from '../../Firebase/FirebaseInit'
export default {
  data () {
    return {
      user: this.$store.getters.user,
      search: '',
      dialog: false,
      createDiag: false,
      show: [],
      sheet: false,
      creator: '',
      names: '',
      intervalVariable: null,
      photoURLs: '',
      projects: [],
      members: [],
      filters: [{title: 'search'}, {title: 'filter by creator'}, {title: 'filter by time', time: '7'}]
    }
  },
  components: {
    vProject: Project,
    vProjectDiag: ProjectDiag
  },
  computed: {
    isCurrentUser () {
      return this.$store.getters.user.id === this.$route.params.id
    },
    filteredProjects () {
      return this.projects.filter((project) => project.title.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  methods: {
    addProject () {
      this.$router.push('/newProject')
    },
    deletes (file) {
      file.projectDialog = false
      firebase.firestore().collection('projects').doc(file.id).delete()
      var co = 0
      for (var i = 0; i <= file.members.length - 1; i++) {
        firebase.firestore().collection('users').doc(file.members[i]).collection('projects').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().projectID === file.id) {
              if (file.members.length === 1) {
                firebase.firestore().collection('users').doc(file.members[0]).collection('projects').doc(doc.id).delete()
              } else {
                firebase.firestore().collection('users').doc(file.members[co]).collection('projects').doc(doc.id).delete()
                co++
              }
            }
          })
        })
      }
      var filteredAry = this.projects.filter(function (e) { return e !== file })
      this.projects = filteredAry
    },
    leave (project) {
      let id = project.id
      firebase.firestore().collection('users').doc(this.user.id).collection('projects').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (doc.data().projectID === id) {
            firebase.firestore().collection('users').doc(this.user.id).collection('projects').doc(doc.id).delete()
          }
        })
      })
      firebase.firestore().collection('projects').doc(id).get().then((doc) => {
        let members = doc.data().members
        for (let i = 0; i < doc.data().members.length; i++) {
          if (doc.data().members[i] === this.$store.getters.user.id) {
            members.splice(i, 1)
          }
        }
        firebase.firestore().collection('projects').doc(id).update({members: members})
      })
      project.projectDialog = false
      for (let j = 0; j < this.projects.length; j++) {
        if (this.projects[j].id === id) {
          this.projects.splice(j, 1)
        }
      }
    },
    out (project) {
      this.createDiag = false
      this.intervalVariable = setInterval(
        this.pullFromDatabase()
      , 12000)
      // this.stopTimer()
    },
    stopTimer () {
      clearInterval(this.intervalVariable)
    },
    dateFormat (string) {
      var startYear = string.substring(0, 4)
      var startMonth = string.substring(5, 7)
      var startDay = string.substring(8, 10)
      var start = startMonth + ' / ' + startDay + ' / ' + startYear
      this.currDate = string
      return start
    },
    funct (projectID) {
      this.$store.dispatch('Project', projectID)
      this.$router.push('/project/' + projectID)
    },
    showInfo (index) {
      this.show.splice(index, 1, !this.show[index])
    },
    pullFromDatabase () {
      this.projects = []
      firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let projectRef = firebase.firestore().collection('projects').doc(doc.data().projectID)
          projectRef.get().then((docu) => {
            let counter = 0
            projectRef.collection('notifications').get().then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (!doc.data().read.includes(this.$store.getters.user.id)) {
                  counter++
                }
              })
              var project = {
                id: doc.data().projectID,
                title: docu.data().title,
                description: docu.data().description,
                startDate: docu.data().startDate,
                endDate: docu.data().endDate,
                members: docu.data().members,
                creator: docu.data().creator,
                unreadMessages: counter
              }
              counter = 0
              this.members[project.id] = []
              for (var i = 0; i < project.members.length; i++) {
                firebase.firestore().collection('users').doc(project.members[i]).get().then((docul) => {
                  var member = {
                    id: docul.data().id,
                    name: docul.data().name,
                    photoURL: docul.data().photoURL
                  }
                  this.members[project.id].push(member)
                })
              }
              firebase.firestore().collection('users').doc(project.creator.id).get().then((docu) => {
                project.creatorID = project.creator.id
                project.creator = docu.data().name
                const oneDay = 1000 * 60 * 60 * 24
                const date1 = new Date(project.startDate)
                const date1Ms = date1.getTime()
                const date2 = new Date(project.endDate)
                const date2Ms = date2.getTime()
                const differenceMs = date2Ms - date1Ms
                project.difference = Math.round(differenceMs / oneDay)
                project.projectDialog = false
                this.projects.push(project)
                this.show.push(false)
              })
            })
          })
        })
      })
    }
  },
  created () {
    this.pullFromDatabase()
  }
}
</script>



// WEBPACK FOOTER //
// ProjectGrid.vue?7167750f